<template>
  <!-- Video card -->
  <el-card class="clip-card box-card">
    <div slot="header" class="videoHeader">
      <video-item-header
        :percent-completed="percentCompleted"
        :title="info.title"
        :status="info.status"
        :progress="info.progress"
        :is-removable="info.isRemovable"
        :sharings="videoSharings"
        :is-uploaded-to-mangomolo="info.isUploadedToMangomolo"
        :is-uploading-to-mangomolo="isUploadingToMangomolo"
        @sharingRemoved="$emit('sharingRemoved', $event)"
        @edit="showEditForm"
        @gif="generateGIF"
        @cut="showCutForm"
        @preview="showVideoPreview"
        @download="downloadClip"
        @copy="clipboardCopy"
        @delete="deleteVideo"
        @cloneVideo="cloneVideoItem"
        @updateTitleStart="$emit('updateTitleStart')"
        @updateTitle="updateTitle"
      />
    </div>

    <!-- Video information -->
    <video-item-content
      :channels="channels"
      :video-info="info"
      :thumbnail-link="thumbnailLink"
      :snapchat-link="snapchatLink"
      :app="app"
      :stream="stream"
      :show-button-share="showButtonShare"
      :duration="clipDuration"
      :is-updating-thumbnail="isUpdatingThumbnail"
      :upload-to-mangomolo="
        !info.isUploadedToMangomolo && !isUploadingToMangomolo
      "
      @changeDescriptionVideo="changeDescriptionVideo"
      @renewThumbnail="generateThumbnail"
      @openShareModal="isShowSharingModal = true"
      @uploadToMangomolo="uploadToMangomolo"
      @playVideoInMediaManager="$emit('playVideoInMediaManager', $event)"
      @preview="showVideoPreview"

    />

    <!-- Video preview form -->
    <modal
      v-show="isShowVideoPreview"
      class="watch-modal"
      :title="previewTitle"
      can-close
      @close="closeVideoPreview"
    >
      <template v-slot:body>
        <video-player
          ref="previewVideoPlayer"
          :options="playerOptions"
          :thumbnail="videoInfo.thumbnailLink"
          :width="playerWidth"
          :height="playerHeight"
        />
      </template>
    </modal>
    <sharing-from-mangomolo
      v-if="sharingMM"
      :title="info.title"
      :multistep-id="info.multistepId"
      :description-info="info.description"
      @closed="sharingMM = false"
      @sharingToMM="sharingToMM"
    />
    <!-- Video sharing form -->
    <sharing-form
      :id="info.id"
      :multistep-id="info.multistepId"
      :visible="isShowSharingModal"
      :title="info.title"
      :clip-duration="clipDuration"
      :clip-width="clipWidth"
      :clip-height="clipHeight"
      :thumbnail-link="thumbnailLink"
      @closed="isShowSharingModal = false"
    />

    <!-- Video edit form -->
    <!--
    <edit-video-form
      v-if="false"
      :visible.sync="isShowEditForm"
      :video-info="videoInfo"
      :thumbnail="thumbnailLink"
      :stream="stream"
      :duration="clipDuration"
      :media-items-list="mediaItemsList"
      :media-tab="mediaTab"
      :is-updating-thumbnail="isUpdatingThumbnail"
      @renewThumbnail="generateThumbnail"
      @shareToMMForStudio="sharingToMM"
      @cut="$emit('cut', $event)"
    />
    -->
    <!-- Video cut form -->
    <!-- <cut-video-modal
      :video-info="videoInfo"
      :visible.sync="isShowCutForm"
      :video-duration="clipDuration"
      :video-src="videoDistribution"
      @cut="$emit('cut', $event)"
    /> -->
  </el-card>
</template>

<script>
/** Item parts */
import VideoItemHeader from "@/components/media/video/VideoItemHeader.vue";
import VideoItemContent from "@/components/media/video/VideoItemContent.vue";
/* rest of imports */
import VideoPlayer from "@/components/media/video/VideoPlayer.vue";
import fallbackImage from "@/assets/images/empty.jpg";
import Modal from "@/components/dialog/Modal.vue";
import SharingForm from "@/components/socials/share/SharingForm.vue";
import SharingFromMangomolo from "@/components/socials/share/SharingFromMangomolo.vue";
import EditVideoForm from "@/components/media/editing/EditVideoForm.vue";
// import CutVideoModal from "@/components/dialog/CutVideoModal.vue";
import { fitSizesToBorders } from "@/utils/size.js";

import { token } from "@/api/params.js";

import { mapState } from "vuex";

import { MEDIA_CONVERSION_STATUS } from "@/constants.js";

// @group Media/Video
// Video card
export default {
  name: "VideoItem",
  components: {
    VideoItemHeader,
    VideoItemContent,
    VideoPlayer,
    Modal,
    SharingForm,
    SharingFromMangomolo,
    EditVideoForm,
    // CutVideoModal
  },
  props: {
    channels: {
      type: Array,
    },
    // Video clip data
    videoInfo: {
      type: Object,
      required: true
    },
    // Link to share clip to Snapchat
    snapchatLink: {
      type: String,
      default: null
    },
    percentCompleted: {
      type: Number,
      default: 0
    },
    openModalExpress: {
      type: Number
    },
    mediaItemsList: {
      type: Object
    },
    mediaTab: {
      type: String
    },
    thumbnailLink:{
      type:String
    },
    downloadLink:{
      type: String
    }
  },
  data() {
    return {
      changeDurationClick: 0,
      openModalExpressSharing: this.openModalExpress,
      info: this.videoInfo,
      isUploadingToMangomolo: false,
      isShowVideoPreview: false,
      isShowEditForm: false,
      isShowCutForm: false,
      fallbackImage,
      showButtonShare: true,
      playerOptions: {
        autoplay: false,
        controls: true,
        fill: true,
        preload: "none",
        cors: true
      },
      // isMangomoloUploading: false,
      isUpdatingThumbnail: false,
      isShowSharingModal: false,
      playerWidth: 0,
      playerHeight: 0,
      playerWidthLimit: document.body.offsetWidth > 768 ? 0.5 : 0.8,
      playerHeightLimit: 0.8,
      sharingMM: false
    };
  },
  computed: {
    ...mapState({
      host: state => state.services.host,
      app: state => state.services.app,
      vod: state => state.services.vod,
      isMediaManager: state => state.services.isMediaManager,
      stream: state => state.services.stream,
      thumbs: state => state.services.thumbs,
      channel: state => state.userData.currentChannel,
      sharings: state => state.socials.sharings,
      currentChannel: state => state.userData.currentChannel
    }),
    thumbsLinkClone() {
      return this.thumbs;
    },
    // @vuese
    // Duration of clip in seconds
    clipDuration() {
      // If metadata not loaded (video is converting), then time is not set
      return this.videoInfo.metadata?.duration;
    },
    newClipDurationClick() {
      return this.changeDurationClick;
    },
    videoDistribution() {
        return { type: "video/mp4", src: this.downloadLink };
    },
    // @vuese
    // Clip width in pixels
    clipWidth() {
      return this.videoInfo.metadata?.width || 1920;
    },
    // @vuese
    // Clip height in pixels
    clipHeight() {
      return this.videoInfo.metadata?.height || 1080;
    },
    // @vuese
    // Preview video form title
    previewTitle: {
      cache: false,
      get() {
        return "Video Preview:" + this.videoInfo.title;
      }
    },
    // @vuese
    // Video sharings data
    videoSharings() {
      return this.sharings.filter(s => s.videoId == this.videoInfo.id);
    }
  },
  watch: {
    // @vuese
    // Update video data
    videoInfo(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.info = newVal;
      }
      if (newVal.isUploadingToMangomolo !== this.isUploadingToMangomolo) {
        this.isUploadingToMangomolo = newVal.isUploadingToMangomolo;
      }
    },
    // @vuese
    // Resize preview video player
    isShowVideoPreview(val) {
      if (val) {
        this.$nextTick(() => {
          // Set preferred width and height for video player
          const maxWidth = document.body.offsetWidth * this.playerWidthLimit;
          const maxHeight = document.body.offsetHeight * this.playerHeightLimit;
          const videoWidth = this.clipWidth;
          const videoHeight = this.clipHeight;
          const widthAddition = -20;
          const heightAddition = widthAddition * (videoHeight / videoWidth);

          const { width: width, height: height } = fitSizesToBorders(
            videoWidth,
            videoHeight,
            maxWidth,
            maxHeight
          );

          this.playerWidth = width + widthAddition;
          this.playerHeight = height + heightAddition;
        });
      }
    }
  },
  methods: {
    updateTitle(newTitle) {
      this.info.title = newTitle;
      this.$emit("updateTitleFinish", this.info);
    },
    changeDescriptionVideo(nevDescription) {
      this.info.description = nevDescription;
      this.$emit("updateDescFinish", this.info);
    },
    cloneVideoItem() {
      this.$emit("cloneVideoItemObj", this.videoInfo);
    },
    // @vuese
    // Open clip preview modal
    showVideoPreview() {
      // Stop player when modal opened
      if(!this.isMediaManager){
        this.$emit("stopPlayer");
        this.$refs.previewVideoPlayer.setSource(
            this.videoDistribution,
            this.thumbnailLink
        );
        this.isShowVideoPreview = true;
      }
      else {
        this.$emit("playVideoInMediaManager", this.videoInfo.id);
      }
    },
    // @vuese
    // Close clip preview modal
    closeVideoPreview() {
      this.isShowVideoPreview = false;
      this.$refs.previewVideoPlayer.resetSource();
    },
    // @vuese
    // Open edit modal form
    showEditForm() {
      this.$emit("stopPlayer");
      // this.isShowEditForm = true;
      const route = this.$router.resolve({
        path: `/clipper/studio`,
        query: {
          token: token,
          duration: this.clipDuration,
          videoInfo: this.videoInfo,
          streamId: this.videoInfo.stream_id,
          stream: this.videoInfo.stream,
          thumbs: this.videoInfo.storageUrl,
          app: this.app,
          videoInfoID: this.videoInfo.id,
          currentChannel: Number(this.currentChannel)
        }
      });
      window.open(route.href, "_blank");
    },
    // @vuese
    // Open cut modal form
    showCutForm() {
      this.$emit("stopPlayer");
      this.isShowCutForm = true;
    },
    // @vuese
    // Remove clip handler
    async deleteVideo() {
      // User tried to rimove clip
      this.$emit("delete");
    },
    // @vuese
    // Open download clip link in new tab
    downloadClip() {
      this.$emit("download");
    },
    // @vuese
    // Copy download clip link
    clipboardCopy() {
      this.$emit("copy");
    },
    sharingToMM(title, titleArabic, description, categoryVideoinfo, stream) {
      this.isUploadingToMangomolo = true;
      if (stream == undefined) {
        stream = this.stream;
      }
      this.$emit("uploadToMangomolo", {
        title,
        titleArabic,
        description,
        stream,
        categoryVideoinfo,
        done: () => {}
      });
    },
    // @vuese
    // Upload clip to Mangomolo service
    uploadToMangomolo() {
      this.sharingMM = true;
    },
    // @vuese
    // Regenerate clip thumbnail
    async generateThumbnail() {
      this.isUpdatingThumbnail = true;
      this.$emit("updatePoster", {
        done: () => {
          this.isUpdatingThumbnail = false;
        },
        success: link => {
          this.info.thumbnailLink = `${this.videoInfo.storageUrl}/${link}`;
        }
      });
    },
    // @vuese
    // Send GIF-generating request
    async generateGIF() {
      this.$emit("gif");
    }
  }
};
</script>

<style>
@keyframes load-sharing {
  from {
    width: 0px;
  }

  to {
    width: 20px;
  }
}
.share-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-buttons a {
  text-decoration: none;
}
.remove-social-sharing-btn {
  cursor: pointer;
}

.watch-modal .modal {
  margin: 0 10px;
}
</style>

<style scoped>
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #aaa;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #aaa;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: #aaa;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: #aaa;
}

.box-card {
  width: 100%;
  margin-bottom: 15px;
  overflow: hidden;
  background-color: #aaaaaa;
  justify-self: center;
}
.videoHeader {
  display: flex;
  justify-content: space-between;
  text-align: center;
}

.el-card__header {
  padding: 10px !important;
}

.el-card__body {
  padding: 10px !important;
}
</style>
